 

export default class MedicalTeam {

    Id: string | undefined;
    NrCrm: string | undefined;
    Acronym: string | undefined;
    Name: string | undefined;
    OccupationTasyCode: number | undefined;
    PhysicalPersonTasyCode: number | undefined;
    OccupationName: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;
    
    static NewInstance() {
        return new MedicalTeam();
    }
}